import { TipsValue } from './../types';
import { getTipsValues } from './getTipsValues';

export const getTipsOptions = (
  orderDetails?: IMerchantOrderTypeDetails,
  isThirdPartyDelivery?: boolean
): {
  label: string;
  value: TipsValue;
}[] => {
  const tipsValues = getTipsValues(orderDetails, isThirdPartyDelivery);

  return [
    {
      label: 'None',
      value: 'none' as const,
    },
    ...tipsValues.map((tipValue) => ({
      label: `${tipValue}%`,
      value: `${tipValue}`,
    })),
    {
      label: 'Other',
      value: 'custom' as const,
    },
  ];
};
